export default __webpack_public_path__ + "images/increase-protein-intake-profile.jpeg";